module.exports = __webpack_public_path__ + "static/softly-sayang-af91bae22484a1550b5f25d434226cb5.mp3";